import DOCUMENT_DOC_IMG from "../../assets/images/illustration/illustrate-document-doc.svg";
import DOCUMENT_JPEG_IMG from "../../assets/images/illustration/illustrate-document-jpeg.svg";
import DOCUMENT_JPG_IMG from "../../assets/images/illustration/illustrate-document-jpg.svg";
import DOCUMENT_PDF_IMG from "../../assets/images/illustration/illustrate-document-pdf.svg";
import DOCUMENT_PNG_IMG from "../../assets/images/illustration/illustrate-document-png.svg";
import DOCUMENT_INVALID_IMG from "../../assets/images/illustration/illustrate-document-valid.svg";
import DOCUMENT_XLSX_IMG from "../../assets/images/illustration/illustrate-document-xlsx.svg";
import DOCUMENT_BMP_IMG from "../../assets/images/illustration/bmp.svg";
import DOCUMENT_GIF_IMG from "../../assets/images/illustration/gif.svg";
import DOCUMENT_TIF_IMG from "../../assets/images/illustration/tif.svg";
import DOCUMENT_PPT_IMG from "../../assets/images/illustration/ppt.svg";
import DOCUMENT_PPTX_IMG from "../../assets/images/illustration/pptx.svg";
import DOCUMENT_TXT_IMG from "../../assets/images/illustration/txt.svg";
import DOCUMENT_ZIP_IMG from "../../assets/images/illustration/zip.svg";
import DOCUMENT_RAR_IMG from "../../assets/images/illustration/rar.svg";
import DOCUMENT_MSG_IMG from "../../assets/images/illustration/msg.svg";

export enum FileMIME {
  PNG = "image/png",
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PDF = "application/pdf",
  XLS = "application/vnd.ms-excel",
  XLSX = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  BMP = "image/bmp",
  GIF = "image/gif",
  TIF = "image/tiff",
  PPT = "application/vnd.ms-powerpoint",
  PPTX = "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  TXT = "text/plain",
  ZIP = "application/zip",
  RAR = "application/x-rar-compressed",
  MSG = "application/vnd.ms-outlook",
}

const fileIcons = {
  [FileMIME.PNG]: DOCUMENT_PNG_IMG,
  [FileMIME.JPG]: DOCUMENT_JPG_IMG,
  [FileMIME.JPEG]: DOCUMENT_JPEG_IMG,
  [FileMIME.PDF]: DOCUMENT_PDF_IMG,
  [FileMIME.XLS]: DOCUMENT_XLSX_IMG,
  [FileMIME.XLSX]: DOCUMENT_XLSX_IMG,
  [FileMIME.DOC]: DOCUMENT_DOC_IMG,
  [FileMIME.DOCX]: DOCUMENT_DOC_IMG,
  [FileMIME.BMP]: DOCUMENT_BMP_IMG,
  [FileMIME.GIF]: DOCUMENT_GIF_IMG,
  [FileMIME.TIF]: DOCUMENT_TIF_IMG,
  [FileMIME.PPT]: DOCUMENT_PPT_IMG,
  [FileMIME.PPTX]: DOCUMENT_PPTX_IMG,
  [FileMIME.TXT]: DOCUMENT_TXT_IMG,
  [FileMIME.ZIP]: DOCUMENT_ZIP_IMG,
  [FileMIME.RAR]: DOCUMENT_RAR_IMG,
  [FileMIME.MSG]: DOCUMENT_MSG_IMG,
};

export const getFileIcon = (mime: FileMIME) => {
  return fileIcons[mime] || DOCUMENT_INVALID_IMG;
};
